import {StateUtils} from '@spartacus/core';
import {B2BDocumentTypeList, DocumentTypeList} from '../../../invoices.model';

export const INVOICES_DOCUMENT_TYPES = '[Invoices] Invoices Details';
export const LOAD_INVOICES_DOCUMENT_TYPES = '[Invoices] Load Invoices Details';
export const LOAD_INVOICES_DOCUMENT_TYPES_SUCCESS = '[Invoices] Load Invoices Details Success';
export const LOAD_INVOICES_DOCUMENT_TYPES_FAIL = '[Invoices] Load Invoices Details Fail';
export const LOAD_INVOICES_DOCUMENT_TYPES_RESET = '[Invoices] Load Invoices Details Reset';

export class LoadInvoicesDocumentTypes extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_INVOICES_DOCUMENT_TYPES;

  constructor() {
    super(INVOICES_DOCUMENT_TYPES);
  }
}

export class LoadInvoicesDocumentTypesSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_INVOICES_DOCUMENT_TYPES_SUCCESS;

  constructor(public payload: B2BDocumentTypeList) {
    super(INVOICES_DOCUMENT_TYPES);
  }
}

export class LoadInvoicesDocumentTypesFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_INVOICES_DOCUMENT_TYPES_FAIL;

  constructor(public payload: any) {
    super(INVOICES_DOCUMENT_TYPES, payload);
  }
}

export class LoadInvoiceDocumentTypesReset extends StateUtils.LoaderResetAction {
  readonly type = LOAD_INVOICES_DOCUMENT_TYPES_RESET;

  constructor() {
    super(INVOICES_DOCUMENT_TYPES);
  }
}

export type CustomInvoicesDocumentTypesActions =
  LoadInvoicesDocumentTypes
  | LoadInvoicesDocumentTypesSuccess
  | LoadInvoicesDocumentTypesFail
  | LoadInvoiceDocumentTypesReset;
